import { ConfirmDialogIdentifier } from 'legacy/lut/components/shared/Confirm/actions'
import { ConfirmationDialog } from 'legacy/lut/components/shared/Confirm/ConfirmationDialog'
import { FC } from 'react'

import { TRANSLATION_KEYS } from '../../translations'

interface IDeleteConfirmDialogProps {
  messageKey: string
}

export const deleteConfirmDialogIdentifier: ConfirmDialogIdentifier =
  'AssortmentDeleteConfirmDialog'

export const DeleteConfirmDialog: FC<IDeleteConfirmDialogProps> = ({ messageKey }) => {
  return (
    <ConfirmationDialog
      translation
      identifier={deleteConfirmDialogIdentifier}
      // text="Are you sure you want to delete this card?"
      text={messageKey}
      submitText={TRANSLATION_KEYS.deleteConfirm.deleteButton}
      cancelText={TRANSLATION_KEYS.deleteConfirm.cancelButton}
    />
  )
}
